import classNames from "classnames/dedupe";

function Row(props) {
  const {
    label = "", rowClassName = "", labelClassName = "", elementWrapperClassName = "", required = false, hasErrors = false, fakeLabel = false,
  } = props;
  function renderRequiredSymbol() {
    if (required === false || props.hideRequiredSymbol) {
      return null;
    }
    return (
      <span className="required-symbol"> *</span>
    );
  }

  function renderLabel() {
    if (props.layout === "elementOnly" || props.floatingLabel) {
      return null;
    }

    const labelClassNames = [];
    labelClassNames.push("control-label");

    if (props.layout === "horizontal") {
      labelClassNames.push("col-sm-3");
    }

    labelClassNames.push(labelClassName);

    if (fakeLabel) {
      return (
        <div
          className={classNames(labelClassNames)}
          data-required={required}
        >

          <strong>
            {label}
            {renderRequiredSymbol()}
          </strong>
        </div>
      );
    }

    return (
      <label
        className={classNames(labelClassNames)}
        data-required={required}
        htmlFor={props.htmlFor}
      >
        {label}
        {renderRequiredSymbol()}
      </label>
    );
  }

  if (props.layout === "elementOnly") {
    return (
      <span>
        {props.children}
      </span>
    );
  }

  const cssClasses = {
    row: ["form-group", props.formGroupClass],
    elementWrapper: [],
  };

  if (props.classNames) {
    cssClasses.row.push(props.classNames);
  }

  if (hasErrors && props.isTouched) {
    cssClasses.row.push("has-error");
    cssClasses.row.push("has-feedback");
  } else if (props.isValid && props.isTouched) {
    cssClasses.row.push("has-feedback");
    cssClasses.row.push("has-success");
  }

  let element = props.children;
  if (props.layout === "horizontal") {
    // Horizontal layout needs a 'row' class for Bootstrap 4
    cssClasses.row.push("row");

    cssClasses.elementWrapper.push("col-sm-9");
    cssClasses.elementWrapper.push(elementWrapperClassName);

    element = (
      <div className={classNames(cssClasses.elementWrapper)}>
        {props.children}
      </div>
    );
  }

  cssClasses.row.push(rowClassName);
  return (
    <div className={classNames(cssClasses.row)}>
      {renderLabel()}
      {element}
    </div>
  );
}

export default Row;
